import { Link } from "react-router-dom";
import { ArrowRight, Boxes, Building2, Layers3, PanelsTopLeft } from "lucide-react";
import { PHOTOS } from "@/lib/site";

const productLines = [
  {
    icon: Layers3,
    label: "Brand tersedia",
    title: "Acrylic Sheet",
    desc: "Acrylic sheet untuk signage, display, interior, furniture, dekorasi, dan kebutuhan proyek.",
    href: "/produk/animax-acrylic-sheet",
    image: PHOTOS.produkSignage,
    status: "Lihat detail",
    active: true,
  },
  {
    icon: Building2,
    label: "Produk tersedia",
    title: "Baja Ringan & Galvalum",
    desc: "Atap galvalum, roofing, baja ringan, aksesoris, dan material pendukung proyek.",
    href: "/produk/baja-ringan-galvalum",
    image: PHOTOS.galvalumWarehouse,
    status: "Lihat detail",
    active: true,
  },
  {
    icon: PanelsTopLeft,
    label: "Segera hadir",
    title: "Kitchen equipments",
    desc: "Kategori perlengkapan dapur untuk kebutuhan komersial, operasional, dan proyek hospitality.",
    status: "Dalam persiapan",
    active: false,
  },
];

export const ProductGateway = () => {
  return (
    <section id="produk" data-testid="product-gateway-section" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-3xl">
          <div className="tag-uppercase text-animax-orange mb-4">Produk & Unit Bisnis</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-animax-black">
            Lini produk yang dapat berkembang mengikuti kebutuhan pelanggan
          </h2>
          <p className="mt-4 text-neutral-600 text-lg leading-relaxed">
            PT APL menyiapkan beberapa kategori produk untuk kebutuhan material, display, retail,
            interior, dan proyek. Setiap lini produk dapat memiliki halaman detail tersendiri agar
            katalog, spesifikasi, dan informasi teknis tetap mudah dipahami.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-3 gap-5">
          {productLines.map((item, index) => {
            const content = (
              <article
                data-testid={`product-line-${index}`}
                className={`group h-full overflow-hidden rounded-2xl border bg-white transition-all ${
                  item.active
                    ? "card-lift border-neutral-200 hover:border-animax-orange"
                    : "border-dashed border-neutral-300 opacity-85"
                }`}
              >
                <div className="relative aspect-[16/10] overflow-hidden bg-neutral-100">
                  {item.image ? (
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center bg-animax-gray">
                      <Boxes className="w-10 h-10 text-neutral-400" />
                    </div>
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-animax-black/75 via-transparent to-transparent" />
                  <div className="absolute left-5 bottom-5 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/90">
                    <item.icon className="w-4 h-4 text-animax-orange" />
                    <span className="tag-uppercase text-animax-black">{item.label}</span>
                  </div>
                </div>

                <div className="p-6">
                  <h3 className="font-display text-2xl font-medium text-animax-black">{item.title}</h3>
                  <p className="mt-3 text-sm text-neutral-600 leading-relaxed min-h-[72px]">{item.desc}</p>
                  <div className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-animax-black group-hover:text-animax-orange">
                    {item.status}
                    {item.active && <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />}
                  </div>
                </div>
              </article>
            );

            return item.active ? (
              <Link key={item.title} to={item.href} className="block">
                {content}
              </Link>
            ) : (
              <div key={item.title}>{content}</div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
